export default function SearchBar({ children }) {
    return (
        <div style={{ position: 'fixed', top:'3.5rem', width: '100%', backgroundColor: '#D0AE6B', color: 'black', padding: '0.5rem 3rem 0.5rem 3rem' }}>
            {children}
        </div>
    );
}